import Index from '@/components/plant/Index.vue'

import Variety from '@/components/plant/variety/Index.vue'
import Scheme from '@/components/plant/programme/Index.vue'
import SchemeList from '@/components/plant/programme/SchemeList.vue'
import SchemeDetail from '@/components/plant/programme/SchemeDetail.vue'

export default {
  path: 'plant',
  component: Index,
  children: [
    /**
     * 品种管理
     */
    {
      path: 'variety',
      component: Variety
    },
    /**
     * 种植方案
     */
    {
      path: 'scheme',
      component: Scheme,
      redirect: 'scheme/list',
      children: [{
        path: 'list',
        component: SchemeList
      }, {
        path: 'add',
        component: SchemeDetail
      }, {
        path: 'edit/:id',
        component: SchemeDetail
      }, ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/plant.js